"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var LftLogotipo_styles_1 = require("./LftLogotipo.styles");
var contexts_1 = require("../../contexts/");
var LftLogotipo = function (_a) {
    var _b = _a.alt, alt = _b === void 0 ? 'logotipo' : _b, ariaLabelLedBy = _a.ariaLabelLedBy, _c = _a.bgColor, bgColor = _c === void 0 ? false : _c, className = _a.className, id = _a.id, logo = _a.logo, style = _a.style, _d = _a.version, version = _d === void 0 ? 'default' : _d;
    if (logo) {
        var template = (0, contexts_1.useTemplate)();
        var image = typeof logo === 'object' ? logo[template] : logo;
        if (image.includes("<svg")) {
            return ((0, jsx_runtime_1.jsx)(LftLogotipo_styles_1.LogoCustomStyled, { alt: alt, "aria-labelledby": ariaLabelLedBy, bgColor: bgColor, className: className, "data-lift": "lft-logotipo", id: id, logo: image, style: style }));
        }
        else {
            return ((0, jsx_runtime_1.jsx)(LftLogotipo_styles_1.LogoCustomStyled, { alt: alt, "aria-labelledby": ariaLabelLedBy, bgColor: bgColor, className: className, "data-lift": "lft-logotipo", id: id, src: image, style: style }));
        }
    }
    switch (version) {
        case 'negative':
            return ((0, jsx_runtime_1.jsx)(LftLogotipo_styles_1.LogoNegativeStyled, { alt: alt, "aria-labelledby": ariaLabelLedBy, bgColor: bgColor, className: className, "data-lift": "lft-logotipo", id: id, version: "negative", style: style }));
        case 'black':
            return ((0, jsx_runtime_1.jsx)(LftLogotipo_styles_1.LogoBlackStyled, { alt: alt, "aria-labelledby": ariaLabelLedBy, bgColor: bgColor, className: className, "data-lift": "lft-logotipo", id: id, version: "black", style: style }));
        case 'white':
            return ((0, jsx_runtime_1.jsx)(LftLogotipo_styles_1.LogoWhiteStyled, { alt: alt, "aria-labelledby": ariaLabelLedBy, bgColor: bgColor, className: className, "data-lift": "lft-logotipo", id: id, version: "white", style: style }));
        default:
            return ((0, jsx_runtime_1.jsx)(LftLogotipo_styles_1.LogoDefaultStyled, { alt: alt, "aria-labelledby": ariaLabelLedBy, bgColor: bgColor, className: className, "data-lift": "lft-logotipo", id: id, version: "default", style: style }));
    }
};
exports.default = LftLogotipo;
